"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lib_1 = require("../lib");
function ErrorFallback({ error, reset, ErrorComponent }) {
    const capture = (0, lib_1.useCapture)();
    (0, react_1.useEffect)(() => {
        console.error(error);
        // Log the error to PostHog.
        // We log it here and not in componentDidCatch in the Error Boundary
        // because if PostHog is still initialising we miss the error
        capture("$exception", {
            error_message: error.message,
            error_name: error.name,
            error_stack: error.stack
        });
    }, [error, capture]);
    if (ErrorComponent) {
        return react_1.default.createElement(ErrorComponent, { error: error, reset: reset });
    }
    return (react_1.default.createElement("div", { "data-testid": "errorBoundary", style: {
            height: "100vh",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        } },
        react_1.default.createElement("h2", { style: { fontSize: "16px", fontWeight: 400, lineHeight: "28px" } }, "Something went wrong!"),
        react_1.default.createElement("button", { style: { cursor: "pointer" }, onClick: 
            // Attempt to recover by trying to re-render the segment
            () => reset() }, "Try again")));
}
exports.default = ErrorFallback;
